import { render, staticRenderFns } from "./IssueList.vue?vue&type=template&id=78cd1088&scoped=true&"
import script from "./IssueList.vue?vue&type=script&lang=js&"
export * from "./IssueList.vue?vue&type=script&lang=js&"
import style0 from "./IssueList.vue?vue&type=style&index=0&id=78cd1088&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cd1088",
  null
  
)

export default component.exports